import * as React from "react";

// UI Frameworks
import { Modal as AntModal } from "antd";
import { ModalProps } from "antd/lib/modal";

interface IProps extends ModalProps {
	children?: React.ReactNode;
}
const Modal: React.FC<IProps> = ({ children, ...restProps }) => {
	return <AntModal {...restProps}>{children}</AntModal>;
};

export default Modal;
